import axiosOriginal from "axios";

const config =
  window.location.pathname === "/kids"
    ? {
        headers: {
          "Ls2pac-config-type": "kids",
        },
      }
    : {
        headers: {
          "Ls2pac-config-type": "pac",
          "Ls2pac-config-name": window["config"],
        },
      };

export const axios = axiosOriginal.create(config);
